/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DownloadZoomPhoneRecordingRequest } from '../models';
/**
 * ZoomPhoneRecordingApi - axios parameter creator
 * @export
 */
export const ZoomPhoneRecordingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ZoomPhone音声ファイル取得API
         * @summary ZoomPhone音声ファイル取得API
         * @param {DownloadZoomPhoneRecordingRequest} [downloadZoomPhoneRecordingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadZoomPhoneRecording: async (downloadZoomPhoneRecordingRequest?: DownloadZoomPhoneRecordingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom/download_zoom_phone_recording`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadZoomPhoneRecordingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoomPhoneRecordingApi - functional programming interface
 * @export
 */
export const ZoomPhoneRecordingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZoomPhoneRecordingApiAxiosParamCreator(configuration)
    return {
        /**
         * ZoomPhone音声ファイル取得API
         * @summary ZoomPhone音声ファイル取得API
         * @param {DownloadZoomPhoneRecordingRequest} [downloadZoomPhoneRecordingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadZoomPhoneRecording(downloadZoomPhoneRecordingRequest?: DownloadZoomPhoneRecordingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadZoomPhoneRecording(downloadZoomPhoneRecordingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZoomPhoneRecordingApi - factory interface
 * @export
 */
export const ZoomPhoneRecordingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZoomPhoneRecordingApiFp(configuration)
    return {
        /**
         * ZoomPhone音声ファイル取得API
         * @summary ZoomPhone音声ファイル取得API
         * @param {DownloadZoomPhoneRecordingRequest} [downloadZoomPhoneRecordingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadZoomPhoneRecording(downloadZoomPhoneRecordingRequest?: DownloadZoomPhoneRecordingRequest, options?: any): AxiosPromise<void> {
            return localVarFp.downloadZoomPhoneRecording(downloadZoomPhoneRecordingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoomPhoneRecordingApi - interface
 * @export
 * @interface ZoomPhoneRecordingApi
 */
export interface ZoomPhoneRecordingApiInterface {
    /**
     * ZoomPhone音声ファイル取得API
     * @summary ZoomPhone音声ファイル取得API
     * @param {DownloadZoomPhoneRecordingRequest} [downloadZoomPhoneRecordingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneRecordingApiInterface
     */
    downloadZoomPhoneRecording(downloadZoomPhoneRecordingRequest?: DownloadZoomPhoneRecordingRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for downloadZoomPhoneRecording operation in ZoomPhoneRecordingApi.
 * @export
 * @interface ZoomPhoneRecordingApiDownloadZoomPhoneRecordingRequest
 */
export interface ZoomPhoneRecordingApiDownloadZoomPhoneRecordingRequest {
    /**
     * 
     * @type {DownloadZoomPhoneRecordingRequest}
     * @memberof ZoomPhoneRecordingApiDownloadZoomPhoneRecording
     */
    readonly downloadZoomPhoneRecordingRequest?: DownloadZoomPhoneRecordingRequest
}

/**
 * ZoomPhoneRecordingApi - object-oriented interface
 * @export
 * @class ZoomPhoneRecordingApi
 * @extends {BaseAPI}
 */
export class ZoomPhoneRecordingApi extends BaseAPI implements ZoomPhoneRecordingApiInterface {
    /**
     * ZoomPhone音声ファイル取得API
     * @summary ZoomPhone音声ファイル取得API
     * @param {ZoomPhoneRecordingApiDownloadZoomPhoneRecordingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneRecordingApi
     */
    public downloadZoomPhoneRecording(requestParameters: ZoomPhoneRecordingApiDownloadZoomPhoneRecordingRequest = {}, options?: AxiosRequestConfig) {
        return ZoomPhoneRecordingApiFp(this.configuration).downloadZoomPhoneRecording(requestParameters.downloadZoomPhoneRecordingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
